export const normalizeTabValue = (value: any): string =>
  value !== undefined && value !== null ? String(value).trim() : '';

const parseTabSegments = (value: string): number[] | null => {
  if (!value) return null;
  const parts = value.split('.');
  const segments: number[] = [];
  for (const part of parts) {
    if (!/^[0-9]+$/.test(part)) {
      return null;
    }
    segments.push(parseInt(part, 10));
  }
  return segments;
};

// Version-style tab comparison: compares each numeric segment so 74.4 < 74.31.
export const compareTabValues = (aRaw: string, bRaw: string) => {
  const a = normalizeTabValue(aRaw);
  const b = normalizeTabValue(bRaw);

  const aEmpty = a === '';
  const bEmpty = b === '';
  if (aEmpty && bEmpty) return 0;
  if (aEmpty) return 1;
  if (bEmpty) return -1;

  const aSeg = parseTabSegments(a);
  const bSeg = parseTabSegments(b);

  if (aSeg && bSeg) {
    const maxLen = Math.max(aSeg.length, bSeg.length);
    for (let i = 0; i < maxLen; i += 1) {
      const aVal = aSeg[i] ?? 0;
      const bVal = bSeg[i] ?? 0;
      if (aVal !== bVal) return aVal - bVal;
    }
    // Preserve fractional precision and leading zero intent by falling back to string compare
    // when numeric segments are equal (e.g., 1.02 vs 1.2).
    return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
  }

  return a.localeCompare(b, undefined, { numeric: true, sensitivity: 'base' });
};
